import { WarningAttachmentsCanNotBeDeleted } from 'owa-locstrings/lib/strings/warningattachmentscannotbedeleted.locstring.json';
import loc, { format } from 'owa-localize';
import { AttachmentInfoBarMessageId } from './AttachmentInfoBarMessageId';
import clearAttachmentInfoBarMessages from './clearAttachmentInfoBarMessages';
import { AttachmentState } from 'owa-attachment-full-data';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';

export const enum AttachmentDeleteFailureReason {
    GenericError,
}

export interface AttachmentDeleteItemFailure {
    item: AttachmentState;
    reason: AttachmentDeleteFailureReason;
}

function addMessageToInfoBar(
    infoMessageId: AttachmentInfoBarMessageId,
    message: string,
    infoBarAddHandler: (
        messageId: string,
        infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
    ) => void
) {
    infoBarAddHandler(infoMessageId, [message]);
}

function showGenericErrorMessage(
    failure: AttachmentDeleteItemFailure,
    infoBarAddHandler: (
        messageId: string,
        infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
    ) => void
) {
    const attachment = getAttachment(failure.item.attachmentId);
    if (attachment) {
        const messageId = 'WarningAttachmentsCanNotBeDeleted';
        const message = format(loc(WarningAttachmentsCanNotBeDeleted), attachment.model.Name);

        addMessageToInfoBar(messageId, message, infoBarAddHandler);
    }
}

export default function showErrorMessagesForDeleteFailure(
    failure: AttachmentDeleteItemFailure,
    infoBarAddHandler: (
        messageId: string,
        infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
    ) => void,
    infoBarRemoveHandler: (inforBarMessageIds: string[]) => void
): void {
    clearAttachmentInfoBarMessages(infoBarRemoveHandler);
    showGenericErrorMessage(failure, infoBarAddHandler);
}
